import { Component, Input } from '@angular/core';
import {PatientTag, NetworkMember} from 'huddyapi';

@Component({
  selector: 'patient-tags',
  templateUrl: './patient-tags.component.html',
  styleUrls: ['./patient-tags.component.scss']
})
export class PatientTagComponent {
  @Input() sourceTags: PatientTag[];
  @Input() context: string;
  @Input() entityId: number;

  tags : PatientTag[]
  entityTypes : string[];
  constructor() {

  }

  ngOnChanges() {
    if (this.sourceTags && this.context && this.entityId) {
      this.entityTypes = this.context.split(',');
      this.tags = this.sourceTags.filter(t => t.entityId === this.entityId && t.tagEntity === this.context);
    }
  }  
  getTagClass(tag : PatientTag) : string {
    let ret : string = 'avatarColor0';
    if (tag.text) {
      ret = NetworkMember.getColorForName(tag.text);
    }
    return ret;
  }

  toInitCase(text : string) {
    return text.substring(0, 1).toUpperCase() + text.substring(1).toLowerCase(); 
  }
}